import React, { useRef, useState } from "react";
import { TooltipButton } from "components/common/TooltipButton";
import { ButtonVariant } from "components/common/Button";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { DropdownMenu } from "components/common/DropdownMenu";
import { DropdownMenuItem } from "components/common/DropdownMenuItem";

export interface ExportMenuActionProps {
  onExportCsv: () => void;
  onExportSheets: () => void;
  onExportParquet?: () => void;
  tooltip?: string | null;
  id?: string;
  variant?: ButtonVariant;
  onOpenChange?: (open: boolean) => void;
}

export const ExportMenuAction: React.FC<ExportMenuActionProps> = (props) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLSpanElement>(null);

  const changeOpen = (next: boolean) => {
    setOpen(next);
    props.onOpenChange?.(next);
  };

  return (
    <>
      <span ref={anchorRef} className="inline-flex">
        <TooltipButton
          id={props.id || "export-menu-button"}
          title={props.tooltip || "Export"}
          size="xs"
          variant={props.variant ?? "default"}
          className={open ? "button-active-state" : ""}
          onClick={() => changeOpen(!open)}
        >
          <DownloadOutlinedIcon />
        </TooltipButton>
      </span>
      <DropdownMenu
        anchorRef={anchorRef}
        isOpen={open}
        onClose={() => changeOpen(false)}
        placement="bottom-end"
      >
        <DropdownMenuItem
          className="px-3 whitespace-nowrap"
          onClick={() => {
            changeOpen(false);
            props.onExportCsv();
          }}
        >
          Export as CSV
        </DropdownMenuItem>
        {props.onExportParquet && (
          <DropdownMenuItem
            className="px-3 whitespace-nowrap"
            onClick={() => {
              changeOpen(false);
              props.onExportParquet?.();
            }}
          >
            Export as Parquet
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          className="px-3 whitespace-nowrap"
          onClick={() => {
            changeOpen(false);
            props.onExportSheets();
          }}
        >
          Export to Google Sheets
        </DropdownMenuItem>
      </DropdownMenu>
    </>
  );
};
